module.exports = __webpack_public_path__ + "img/logo-bluspeed.5f7e8301.png";